/**
 * Single source of truth for Native Form receiving addresses.
 * "Pickup Request" Form (id dbfgat0ob50fdbpndb70), created for this project in Phase 02B.
 * Leave empty to disable live submission (UNCONFIGURED state). Never point at another project's Form.
 * Marketplace "Use Template" rebinding of this value is UNVERIFIED — check it in every new copy.
 */
export const PICKUP_FORM_URL = 'https://readdy.ai/api/form/dbfgat0ob50fdbpndb70';